export default {
  routes: [
    {
      name: 'fileManager',
      path: '/admin/filemanager',
      component: () => import('./views/TheFileManager.vue'),
    },
  ]
}
